import type { AxiosRequestConfig } from 'axios';

import { WidgetGrouping } from 'common/Widgets/types';

import axios from '../config/axiosPrivate';

interface PayloadType {
  filters: {
    competitors: number[];
    care_types: number[];
    room_types: number[];
    room_types_price_display?: number;
    care_levels: number[];
    medication_levels?: number[];
    review_sources: number[];
    review_categories: number[];
    swot_categories: number[];
    care_levels_stats_type?: number;
    medication_levels_stats_type?: number;
    community_contract_type?: number;
    community_contract_selection_type?: number;
    community_contracts?: number[];
    contract_types?: number[];
    end_created_at?: string | null;
  };
  group_by?: WidgetGrouping;
  price_display?: number;
  public_hash?: string;
  show_contract_label_annotations?: boolean;
  snapshots?: string[] | null;
}

export const fetchData = async (
  communityId: number,
  widgetType: number,
  range_type: string,
  payload: PayloadType,
  config?: AxiosRequestConfig
) => {
  const url = `/views/${communityId}/data/${widgetType}/${range_type}`;
  const response = await axios.post(url, payload, config);
  return response.data;
};
